import { render, staticRenderFns } from "./CarriageTable.vue?vue&type=template&id=8e9f8044&"
import script from "./CarriageTable.vue?vue&type=script&lang=js&"
export * from "./CarriageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports